<template>
  <div class="deposit-done-links">
    <button
      type="button"
      @click.prevent="onDone"
      class="button button--large button--primary button--full-width"
    >
      Done
    </button>
    <span
      v-if="showPendingLink"
      @click.prevent="onViewPendingDeposits"
      class="deposit-done-links__link"
    >
      View Pending Deposits
    </span>
  </div>
</template>

<script src="./deposit-done-links.js"></script>
<style src="./deposit-done-links.scss" lang="scss"></style>
